import { useCompletePortoneReservation } from "@/components/EventReservation/useCompletePortoneReservation";
import { Box, LoadingOverlay, Paper, Text, Title } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export const PaymentSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { completeReservation } = useCompletePortoneReservation();
  const [isProcessing, setIsProcessing] = useState(true);
  const hasProcessedRef = useRef(false);

  const paymentId = searchParams.get("paymentId");

  useEffect(() => {
    const completePayment = async () => {
      // Guard against duplicate submissions (React Strict Mode, re-renders, etc.)
      if (hasProcessedRef.current) {
        return;
      }
      hasProcessedRef.current = true;
      if (!paymentId) {
        hasProcessedRef.current = false; // Reset flag
        notifications.show({
          title: "결제 정보 오류",
          message: "결제 정보를 확인할 수 없습니다.",
          color: "red",
        });
        setIsProcessing(false);
        return;
      }

      try {
        await completeReservation(paymentId);
      } catch (error) {
        console.error("Failed to complete reservation:", error);

        // Navigate to failure page with error details
        const errorMessage = error instanceof Error ? error.message : "예약 생성에 실패했습니다.";
        navigate(
          `/payment/fail?code=RESERVATION_FAILED&message=${encodeURIComponent(errorMessage)}`
        );
      }
    };

    completePayment();
  }, [completeReservation, paymentId, navigate]);

  return (
    <Paper p="md" shadow="xs" withBorder>
      <LoadingOverlay visible={isProcessing} overlayProps={{ radius: "sm", blur: 2 }} />
      <Title order={3} ta="center">
        {isProcessing ? "예약 처리 중" : "처리 완료"}
      </Title>
      <Text c="dimmed" size="sm" ta="center" mt="sm">
        {isProcessing
          ? "잠시만 기다려주세요. 결제 정보를 확인하고 예약을 완료하고 있습니다."
          : "예약이 완료되었습니다."}
      </Text>
      {!isProcessing && (
        <Box mt="lg">
          <Text>
            <strong>결제 ID:</strong> {paymentId}
          </Text>
        </Box>
      )}
    </Paper>
  );
};
